export const USE_VEHICLE = {
	PRIVATE:'Particular',
	TAXI:'Taxi',
	COMMERCIAL: 'Comercial'
};

export const TYPE_ENERGY = {
	GASOLINE: 'Gasolina',
	DIESEL: 'Diesel',
	GAS: 'Gas',
	GAS_GASOLINE: 'Gas y gasolina',
	ELECTRIC:'Eléctrico'
}

export const ACCESORIES = {
	OPTIONS: [
		{
			id: 'RADIO',
			title: 'Radio'
		},
		{
			id: 'COMPONENTS',
			title: 'Componentes'
		},
		{
			id: 'SPEAKERS',
			title: 'Parlantes'
		},
		{
			id: 'AMPLIFIERS',
			title: 'Amplificador'
		},
		{
			id: 'EQUALIZERS',
			title: 'Ecualizador'
		},
		{
			id: 'SUBWOOFER',
			title: 'Subwoofer'
		},
		{
			id: 'WHEEL',
			title: 'Llantas'
		},
		{
			id: 'RIM',
			title: 'Aros'
		}
	]
}

export const MESSAGES_WITHOUT_PICTURES = {
	type_01: 'accesorios.',
	type_02: 'daños.',
	MESSAGE: '¡No olvides revisar las fotos del auto para verificarlo!'
}



// WEBPACK FOOTER //
// ./src/constants/app/vehicle.js